const DEVICE_ID_KEY = 'im_device_id'

/**
 * 获取稳定的 deviceId：
 * - 优先使用本地缓存
 * - 缓存缺失时立即生成本地稳定 UUID
 * - 避免冷启动阶段为生成指纹阻塞登录与首屏渲染
 */
export async function getStableDeviceId() {
	const cached = localStorage.getItem(DEVICE_ID_KEY)
	if (cached) {
		return cached
	}
	const deviceId = generateFallbackId()
	localStorage.setItem(DEVICE_ID_KEY, deviceId)
	return deviceId
}

function generateFallbackId() {
	if (typeof crypto !== 'undefined' && crypto.randomUUID) {
		return crypto.randomUUID()
	}
	return `${Date.now()}_${Math.random().toString(16).slice(2, 10)}`
}
